import { Navigate } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const CommercialPrivateRouter = ({children}) => {
    const token = localStorage.getItem('jwt')

    if (!token || token === 'undefined') {
        return <Navigate to="/"/>
    }

    let role = ''

    try {
        const token_decode = jwtDecode(token)
        role = String(token_decode.rol || '').toLowerCase()
    } catch (error) {
        return <Navigate to="/"/>
    }

    if(role === 'commercial'){
        return children
    }

    return <Navigate to="/"/>
}

export default CommercialPrivateRouter
